export const messages = {
  en: {
    storeOrderCartDetail: {
      title: 'Order Detail',
      orderInfo: 'Order Information',
      productInfo: 'Product Information',
      feeInfo: 'Fee Information',
      ledgerInfo: 'Ledger Information',
      discountInfo: 'Discount Information',
      receiverInfo: 'Receiver Information',
      operationInfo: 'Operation Information',
      orderId: 'Order ID',
      totalAmount: 'Total Amount',
      orderTime: 'Order Time',
      user: 'User',
      profitSharing: 'Profit Sharing',
      platform: 'Platform',
      productImage: 'Product Image',
      productName: 'Product Name',
      productId: 'Product ID',
      quantity: 'Quantity',
      payAmount: 'Pay Amount',
      status: 'Status',
      payTime: 'Pay Time',
      feeName: 'Fee Name',
      amount: 'Amount',
      payMethod: 'Pay Method',
      merchant: 'Merchant',
      spec: 'Spec',
      ledgerAmount: 'Ledger Amount',
      recharge: 'Recharge',
      objectId: 'Object ID',
      discountMethod: 'Discount Method',
      discountAmount: 'Discount Amount',
      description: 'Description',
      time: 'Time',
      username: 'Username',
      phone: 'Phone',
      address: 'Address',
      remark: 'Remark',
      operationTime: 'Operation Time',
      operationDesc: 'Operation Description'
    }
  },
  zh: {
    storeOrderCartDetail: {
      title: '订单详情',
      orderInfo: '订单信息',
      productInfo: '商品信息',
      feeInfo: '费用信息',
      ledgerInfo: '分账信息',
      discountInfo: '优惠信息',
      receiverInfo: '收货人信息',
      operationInfo: '操作信息',
      orderId: '订单编码',
      totalAmount: '总金额',
      orderTime: '下单时间',
      user: '用户',
      profitSharing: '是否分账',
      platform: '平台',
      productImage: '商品图片',
      productName: '商品名称',
      productId: '商品编号',
      quantity: '数量',
      payAmount: '支付金额',
      status: '状态',
      payTime: '支付时间',
      feeName: '费用名称',
      amount: '金额',
      payMethod: '支付方式',
      merchant: '商户',
      spec: '规格',
      ledgerAmount: '分账金额',
      recharge: '充值',
      objectId: '对象编号',
      discountMethod: '优惠方式',
      discountAmount: '优惠金额',
      description: '说明',
      time: '时间',
      username: '用户名称',
      phone: '手机号码',
      address: '收货地址',
      remark: '备注',
      operationTime: '操作时间',
      operationDesc: '操作说明'
    }
  }
}